<template>
  <div>
    <FITModal ref="commModal" reference="modal" :title="modalTitle" @click="onClickModals">
      <div slot="body">
        <h5 v-if="commissionType === 'pending'">{{$t('osm.product.commission.modifyPending', {action:commissionAction, number: (selectedRow+1)})}}</h5>
        <h5 v-if="commissionType === 'current'">{{$t('osm.product.commission.currentCommissionModal')}}</h5>
      </div>
    </FITModal>
    <div v-if="isCommListArray && commissionList.length > 0 && (commissionType === 'pending' || commissionType === 'history')">
      <template v-for="(listItem,index) in commissionList">
        <hr v-if="index > 0">
        <b-row align-v="center" align-h="between" @click="onToggleShowSet(index)" style="cursor:pointer">
          <b-col cols="6">
            <h4>{{$t('osm.product.commissionSet')}} {{ index+1}}</h4>
          </b-col>
          <b-col cols="auto" class="ml-auto">
            <h4 class="fas fa-angle-up" v-if="!listItem.isShowing"></h4>
            <h4 class="fas fa-angle-down" v-if="listItem.isShowing"></h4>
            <!-- <FITButton :variant="listItem.isShowing?'danger':''" :text="listItem.isShowing? '-': '+'" @click="onToggleShowSet(index)"></FITButton> -->
          </b-col>
        </b-row>
        <template v-if="listItem.isShowing">
          <b-row>
            <b-col cols="6">
              <FITDatePicker field='commissionEffectiveFrom' :disabled="commissionType === 'history'" :label="$t('osm.product.commissionEffectiveFrom')" :width="8" v-model="commissionList[index].commissionEffectiveFrom"></FITDatePicker>
              <FITTextInput field='year1AnnualBonus' :disabled="commissionType === 'history'" :label="$t('osm.product.year1AnnualBonus')" :width="8" v-model="commissionList[index].year1AnnualBonus"></FITTextInput>
              <FITTextInput field='year1Override' :disabled="commissionType === 'history'" :label="$t('osm.product.year1Override')" :width="8" v-model="commissionList[index].year1Override"></FITTextInput>
              <template v-for="item in 7">
                <FITTextInput :field="`year${item}Comm`" :disabled="commissionType === 'history'" :label="$t('osm.product.yearComm', {year: item})" :width="8" v-model="commissionList[index][`year${item}Comm`]"></FITTextInput>
              </template>
            </b-col>
            <b-col cols="6">
              <FITDatePicker field='commissionEffectiveTo' :disabled="commissionType === 'history'" :label="$t('osm.product.commissionEffectiveTo')" :width="8" v-model="commissionList[index].commissionEffectiveTo"></FITDatePicker>
              <FITTextInput field='year2AnnualBonus' :disabled="commissionType === 'history'" :label="$t('osm.product.year2AnnualBonus')" :width="8" v-model="commissionList[index].year2AnnualBonus"></FITTextInput>
              <FITTextInput field='year2Override' :disabled="commissionType === 'history'" :label="$t('osm.product.year2Override')" :width="8" v-model="commissionList[index].year2Override"></FITTextInput>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <FITAlert :ref="`commissionSetAlert${index}`" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
            </b-col>
            <b-col cols="auto" class="ml-auto" v-if="commissionType != 'history'">
              <FITButton :text="$t('general.save')" variant="primary" @click="modifyCommissionRate(index, 'pending')" class="text-center"></FITButton>
              <!-- <FITButton v-if="index == (commissionList.length - 1) && listItem.isCreating" :text="$t('general.add')" variant="warning" @click="modifyCommissionRate('addComm',index)" class="text-center"></FITButton> -->
            </b-col>
          </b-row>
        </template>
      </template>
    </div>
    <template v-if="!isCommListArray && commissionType === 'current'">
      <b-row>
        <b-col cols="6">
          <FITDatePicker field='commissionEffectiveFrom' :label="$t('osm.product.commissionEffectiveFrom')" :width="8" v-model="commissionList.commissionEffectiveFrom"></FITDatePicker>
          <FITTextInput field='year1AnnualBonus' :label="$t('osm.product.year1AnnualBonus')" :width="8" v-model="commissionList.year1AnnualBonus"></FITTextInput>
          <FITTextInput field='year1Override' :label="$t('osm.product.year1Override')" :width="8" v-model="commissionList.year1Override"></FITTextInput>
          <template v-for="item in 7">
            <FITTextInput :field="`year${item}Comm`" :label="$t('osm.product.yearComm', {year: item})" :width="8" v-model="commissionList[`year${item}Comm`]"></FITTextInput>
          </template>
        </b-col>
        <b-col cols="6">
          <FITDatePicker field='commissionEffectiveTo' :label="$t('osm.product.commissionEffectiveTo')" :width="8" v-model="commissionList.commissionEffectiveTo"></FITDatePicker>
          <FITTextInput field='year2AnnualBonus' :label="$t('osm.product.year2AnnualBonus')" :width="8" v-model="commissionList.year2AnnualBonus"></FITTextInput>
          <FITTextInput field='year2Override' :label="$t('osm.product.year2Override')" :width="8" v-model="commissionList.year2Override"></FITTextInput>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <FITAlert ref="currentCommissionAlert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
        </b-col>
        <b-col cols="auto" class="ml-auto" v-if="commissionType != 'history'">
          <FITButton :text="$t('general.save')" variant="primary" @click="modifyPendingCommRate" class="text-center"></FITButton>
        </b-col>
      </b-row>
    </template>
    <template v-if="!isCommListArray && commissionType === 'new'">
      <b-row>
        <b-col cols="6">
          <FITDatePicker field='commissionEffectiveFrom' :label="$t('osm.product.commissionEffectiveFrom')" :width="8" v-model="value.commissionEffectiveFrom"></FITDatePicker>
          <FITTextInput field='year1AnnualBonus' :label="$t('osm.product.year1AnnualBonus')" :width="8" v-model="value.year1AnnualBonus"></FITTextInput>
          <FITTextInput field='year1Override' :label="$t('osm.product.year1Override')" :width="8" v-model="value.year1Override"></FITTextInput>
          <template v-for="item in 7">
            <FITTextInput :field="`year${item}Comm`" :label="$t('osm.product.yearComm', {year: item})" :width="8" v-model="value[`year${item}Comm`]"></FITTextInput>
          </template>
        </b-col>
        <b-col cols="6">
          <FITDatePicker field='commissionEffectiveTo' :label="$t('osm.product.commissionEffectiveTo')" :width="8" v-model="value.commissionEffectiveTo"></FITDatePicker>
          <FITTextInput field='year2AnnualBonus' :label="$t('osm.product.year2AnnualBonus')" :width="8" v-model="value.year2AnnualBonus"></FITTextInput>
          <FITTextInput field='year2Override' :label="$t('osm.product.year2Override')" :width="8" v-model="value.year2Override"></FITTextInput>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import {
  FITFormCard,
  FITTextInput,
  FITTextarea,
  FITButton,
  FITModal,
  FITAutoSearch,
  FITSelect,
  FITDatePicker,
  FITAlert,
  CommissionSection
} from '@/components'
export default {
  name: 'CommissionSection',
  props: {
    commList: {
      type: [Array, Object],
      default: () => {}
    },
    value: {
      type: [Object]
    },
    commissionType: {
      type: String,
      default: ''
    }
  },
  created() {

    if (this.commissionType === 'new') {
      return;
    }
    if (this.commList instanceof Array) {
      this.setCommissionRateList(this.commList, 'array');
    } else {
      this.setCommissionRateList(this.commList, 'object');
    }
  },
  data() {
    return {
      commissionList: {},
      selectedRow: 0,
      selectedAction: 'editComm',
      alertParams: {
        content: `<i class="fas fa-check-circle"></i> ${this.$t('general.updateSuccess')}`,
        variant: 'success'
      },
    }
  },
  methods: {
    onClickModals(event) {
      if (!event) {
        return;
      }
      var data = []
      if (this.commissionType === 'pending') {
        data = this.convertCommToSend(this.commissionList[this.selectedRow]);
      }
      if (this.commissionType === 'current') {
        data = this.convertCommToSend(this.commissionList);
      }
      this.$store.dispatch('Product/editCommissionRate', data).then((json) => {
        Vue.set(this, 'alertParams', this.successAlertContent);
        if (this.commissionType === 'pending') {
          this.$refs[`commissionSetAlert${this.selectedRow}`][0].showAlert();
        } else if (this.commissionType === 'current') {
          this.$refs.currentCommissionAlert.showAlert();
        }
        this.$emit('onModified');
        this.$refs.commModal.closeModal();
      }).catch((err) => {
        console.error(err);
        Vue.set(this, 'alertParams', this.errorAlertContent);
        if (this.commissionType === 'pending') {
          this.$refs[`commissionSetAlert${this.selectedRow}`][0].showAlert();
        } else if (this.commissionType === 'current') {
          this.$refs.currentCommissionAlert.showAlert();
        }
      })

    },
    convertFloatToPercent(input) {
      var ans = (parseFloat(input) * 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },
    convertPercentToFloat(input) {
      var ans = (input / 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },
    convertCommToSend(comm) {
      var data = JSON.parse(JSON.stringify(comm));
      data['year1AnnualBonus'] = this.convertPercentToFloat(data.year1AnnualBonus);
      data['year2AnnualBonus'] = this.convertPercentToFloat(data.year2AnnualBonus);
      data['year1Override'] = this.convertPercentToFloat(data.year1Override);
      data['year2Override'] = this.convertPercentToFloat(data.year2Override);
      for (var i = 1; i < 8; i++) {
        data[`year${i}Comm`] = this.convertPercentToFloat(data[`year${i}Comm`]);
      };
      delete data.isShowing
      console.debug(data);
      return data
    },
    onToggleShowSet(index) {
      Vue.set(this.commissionList[index], 'isShowing', !this.commissionList[index].isShowing);
    },
    modifyPendingCommRate() {
      this.$refs.commModal.openModal();
    },
    modifyCommissionRate(index) {
      Vue.set(this, 'selectedRow', index);
      this.$refs.commModal.openModal();
    },
    setCommissionRateList(list, type) {
      if (type === 'object') {
        var obj = {
          'ID': list.ID,
          'year1AnnualBonus': this.convertFloatToPercent(list.year1AnnualBonus),
          'year2AnnualBonus': this.convertFloatToPercent(list.year2AnnualBonus),
          'year1Override': this.convertFloatToPercent(list.year1Override),
          'year2Override': this.convertFloatToPercent(list.year2Override),
          'commissionEffectiveTo': list.commissionEffectiveTo,
          'commissionEffectiveFrom': list.commissionEffectiveFrom
        }
        for (var i = 1; i < 8; i++) {
          obj[`year${i}Comm`] = this.convertFloatToPercent(list[`year${i}Comm`]);
        };
        Vue.set(this, 'commissionList', obj);
        return;
      }
      var data = []
      list.forEach((item, index) => {
        var obj = {
          'ID': item.ID,
          'year1AnnualBonus': this.convertFloatToPercent(item.year1AnnualBonus),
          'year2AnnualBonus': this.convertFloatToPercent(item.year2AnnualBonus),
          'year1Override': this.convertFloatToPercent(item.year1Override),
          'year2Override': this.convertFloatToPercent(item.year2Override),
          'commissionEffectiveTo': item.commissionEffectiveTo,
          'commissionEffectiveFrom': item.commissionEffectiveFrom,
          'isShowing': false
        }
        for (var i = 1; i < 8; i++) {
          obj[`year${i}Comm`] = this.convertFloatToPercent(item[`year${i}Comm`]);
        };
        data.push(obj);
      })
      Vue.set(this, 'commissionList', data);
    },
  },
  computed: {
    isCommListArray() {
      return this.commissionList instanceof Array
    },
    commissionAction() {
      return 'edit';
    },
    modalTitle() {
      return this.$t('osm.product.commission.editCommission')
    },
    successAlertContent() {
      return { content: `<i class="fas fa-check-circle"></i> ${this.$t('general.updateSuccess')}`, variant: 'success' }
    },
    errorAlertContent() {
      return { content: `<i class="fas fa-check-circle"></i> ${this.$t('general.updateError')}`, variant: 'danger' }
    },
  },
  watch: {
    commList: {
      deep: true,
      handler: function(newData, oldData) {
        if (this.commList instanceof Array) {
          this.setCommissionRateList(newData, 'array');
        } else {
          this.setCommissionRateList(newData, 'object');
        }
      }
    }
  },
  components: {
    FITFormCard,
    FITTextInput,
    FITTextarea,
    FITButton,
    FITModal,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITAlert,
  },
}

</script>



// WEBPACK FOOTER //
// src/Osm/Product/components/CommissionSection.vue